export enum GoogleTagManagerSubjectEnums {
    Funnel = 'funnel',
    GeneralWorkflow = 'generalWorkflow',
    GeneralWorkflowProducts = 'generalWorkflowProducts',
    AccountRegistration = 'accountRegistration'
}
